/**
 * Data Provider - Selects adapter based on configuration
 */

import { config } from "@/lib/config";
import * as externalApi from "./adapters/externalApi";
import * as supabase from "./adapters/supabase";

const adapters = {
  externalApi,
  supabase,
};

const selectedAdapter = adapters[config.DATA_ADAPTER];

export const {
  productsAdapter,
  stockAdapter,
  batchesAdapter,
  salesAdapter,
  ingredientsAdapter,
  usersAdapter,
  reportsAdapter,
  categoriesAdapter,
  unitsAdapter,
  entradaAdapter,
  estoqueAdapter,
  tipoProdutosAdapter,
  estabelecimentosAdapter,
  clientesAdapter,
  vendasAdapter,
  receitasAdapter,
  fornadasAdapter,
  tipoMovimentoEntradaAdapter,
  tipoDocumentoAdapter,
  formaPagamentoAdapter,
  categoriaReceitaAdapter,
  nivelDificuldadeAdapter,
  fornecedorAdapter,
  marcaAdapter,
} = selectedAdapter as any;
